import { useTranslation } from 'react-i18next'
import { Package, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'

type ProductCatalogEmptyProps = {
  onAddClick: () => void
}

export function ProductCatalogEmpty({ onAddClick }: ProductCatalogEmptyProps) {
  const { t } = useTranslation('productCatalog')

  return (
    <div className='flex flex-col items-center justify-center rounded-lg border border-dashed py-16 px-4'>
      <Package className='mb-4 size-12 text-muted-foreground' />
      <h3 className='text-lg font-semibold'>{t('empty.title')}</h3>
      <p className='mt-1 max-w-sm text-center text-muted-foreground'>
        {t('empty.description')}
      </p>
      <Button className='mt-6 gap-2' onClick={onAddClick}>
        <Plus className='size-4' />
        {t('empty.addButton')}
      </Button>
    </div>
  )
}
